import React, { useState, useEffect, useMemo, useContext } from 'react';
import { Provider, useStore } from 'react-redux';
import PropTypes from 'prop-types';

import CustomOverlay, { initialize } from './customOverlay';
import { GOOGLE, MAP, MapContext } from './constants';

export const initializeOverlay = ({
	[MAP]: map, [GOOGLE]: google, appendToMap, overlay, setOverlay, position, children,
	offsetY, disableIdleEvent, className, gesturesDisabled, idleDisabled, animationDelay
}) => {
	if (map && google && !overlay) {
		initialize(google);

		const newOverlay = new CustomOverlay({
			idleDisabled,
			appendToMap,
			className,
			gesturesDisabled,
			position: new google.maps.LatLng(position),
			component: children,
			map,
			offsetY,
			disableIdleEvent,
			google,
			animationDelay
		});

		setOverlay(newOverlay);
	}
};

const CustomOverlayComponent = (props) => {
	const {
		children,
		position,
		offsetY,
		className,
		gesturesDisabled,
		idleDisabled,
		animationDelay,
		zIndex,
		appendToMap,
		disableIdleEvent: disableIdleEventProp,
	} = props;
	const mapContext = useContext(MapContext);
	const map = mapContext[MAP];
	const google = mapContext[GOOGLE];
	const disableIdleEvent = disableIdleEventProp || mapContext.disableIdleEvent;
	const store = useStore();
	const [overlay, setOverlay] = useState(null);

	const wrappedChildren = useMemo(() => (
		<Provider store={store}>
			{children}
		</Provider>
	), [children, store]);

	// Initialize overlay on mount and update
	useEffect(() => {
		initializeOverlay({
			[MAP]: map,
			[GOOGLE]: google,
			appendToMap,
			overlay,
			setOverlay,
			position,
			children: wrappedChildren,
			offsetY,
			disableIdleEvent,
			className,
			gesturesDisabled,
			idleDisabled,
			animationDelay,
		});
	});

	// Update zIndex when changed
	useEffect(() => {
		if (overlay) {
			overlay.setZIndex(zIndex);
		}
	}, [zIndex, overlay]);

	// Update component when children change
	useEffect(() => {
		if (overlay) {
			overlay.updateComponent(wrappedChildren);
		}
	}, [wrappedChildren, overlay]);

	// Cleanup on unmount
	useEffect(() => {
		return () => {
			if (overlay) {
				overlay.setMap(null);
			}
		};
	}, [overlay]);

	return null;
};

export default CustomOverlayComponent;
